<template>
  <div>
    <!-- <div style="font-size:18px">
      merchantId: {{testQuery.merchantId}}
    </div>
    <div style="font-size:18px">sn: {{testQuery.sn}}</div> -->
    <div style="height:100vh"
         class="loginImageBG">
      <img src="../assets/images/agt_logo.png"
           class="imgbg"
           mode='aspectFit' />
      <div class="text1">
        <span style="font-weight:500;font-size:35px">乐享付</span>
      </div>
<!--      <div v-if="dataInfo.merAccount" style="margin-top:20px">-->
<!--        <div style="text-align:center">-->
<!--          <span style="font-size:15px">APP登录用户名：{{dataInfo.merAccount}}</span>-->
<!--        </div>-->
<!--        <div style="text-align:center;margin-top:10px">-->
<!--          <span style="font-size:15px">APP登录初始密码：身份证后六位</span>-->
<!--        </div>-->
<!--      </div>-->
      <div style="text-align:center;position:absolute;bottom:50px">
        <img src="../assets/images/iphoneButton.png"
             class="imgButton"
             mode='aspectFit'
             @click="godownloadIphone()"/>
        <img src="../assets/images/androidButton.png"
             class="imgButton"
             style="margin-top:25px"
             mode='aspectFit'
             @click="godownloadAndroid()"/>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
export default {
  data () {
    return {
      testQuery: {},
      docHeight: '',
      dataInfo: {}
    }
  },
  mounted () {
    this.testQuery = this.$route.query
    this.$nextTick(() => {
      let docHeight = document.documentElement.clientHeight
      console.log('可视区域高度', docHeight)
      this.docHeight = docHeight + 'px'
      // 获取屏幕高度，为元素添加高度
      // 不使用 100vh 的原因：安卓手机上，键盘抬起会算作屏幕元素，100vh会发生变化，键盘收起时，100vh会比初始值小
      let isWeixin = (function () { return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1 })()
      if (isWeixin) {
        Toast({
          message: '请在浏览器打开下载',
          position: 'top'
        })
      }
      this.getMercInfo()
    })
  },
  methods: {
    async getMercInfo () {
      const { sn } = this.testQuery
      let params = {}
      if (sn) {
        const requestUrl = '/api/cold-butler-compose/MerAppSkip/getMerApp'
        params.chnSnNo = sn
        const res = await this.getRequest(requestUrl, params)
        if (res && res.data.code === 200) {
          this.dataInfo = res.data.data
        }
      }
    },
    async getLink (type) {
      const { tenantId } = this.testQuery
      let params = {}
      // let requestUrl = '/api/cold-butler-compose/MerAppSkip/getMerAppByTenantId'
      let requestUrl = '/api/cold-light-core/AppVersion/getAppUrl'
      let urlInfo = {}
      try {
        if (tenantId) {
          params.tenantId = tenantId
          const res = await this.getRequest(requestUrl, { ...params, ...type })
          if (res && res.data.code === 200) {
            urlInfo = res.data.data
          }
        }
        return urlInfo
      } catch (err) {
        console.log(err)
        return null
      }
    },
    async godownloadIphone () {
      alert('即将跳转到Apple商店')
      if (this.dataInfo.iosDownloadUrl) {
        window.location.href = this.dataInfo.iosDownloadUrl
        return
      }
      const downloadInfo = await this.getLink({ type: 'agtIos' })
      if (typeof downloadInfo === 'string') {
        window.location.href = downloadInfo
      } else {
        Toast('暂无下载地址')
      }
    },
    async godownloadAndroid () {
      if (this.dataInfo.androidDownloadUrl) {
        window.open(this.dataInfo.androidDownloadUrl)
        return
      }
      const downloadInfo = await this.getLink({ type: 'agtAndroid' })
      if (typeof downloadInfo === 'string') {
        window.open(downloadInfo)
      } else {
        Toast('暂无下载地址')
      }
    }
  }
}
</script>

<style scoped>
.loginImageBG {
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;
  background-image: url("../assets/images/downloadBg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 100vw;
  height: 100vh;
  /* overflow: auto; */
  position:relative
}
.imgbg {
  width: 100px;
  height: 100px;
  margin-top: 80px;
}
.text1{
  text-align:center;
  margin-top:20px
}
.imgButton{
  width: 70%;
  height: 60px;
}
</style>
